import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RelativeTimePipe } from './relative-time.pipe';
import { FutureRelativeTimePipe } from './future-relative-time.pipe';
import { ExcerptPipe } from "./excerpt.pipe";
import { GetValueByKeyPipe } from './get-value-by-key.pipe';
import { SafeHtmlPipe } from './safe-html/safe-html.pipe';
import { ConvertToLocalTimePipe } from './convert-to-local-time.pipe';
import { IsNotNumberPipe } from './is-not-number.pipe';

const pipes = [
  RelativeTimePipe,
  FutureRelativeTimePipe,
  ExcerptPipe,
  GetValueByKeyPipe,
  SafeHtmlPipe,
  ConvertToLocalTimePipe,
  IsNotNumberPipe
]

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: pipes,
  exports: pipes
})
export class SharedPipesModule { }